/**
 * Comps database (register: Comp Database / item 17) — real transaction
 * comps search by geography and asset type. Used by the Property tab's
 * Comparables panel; never fabricate a comp row.
 */

import api from '@/services/api'
import { toCamelCase } from '@/utils/transform'

export type CompRecord = {
  id: string
  propertyName: string
  address: string | null
  city: string | null
  state: string | null
  metro: string | null
  submarket: string | null
  zipCode: string | null
  lat: number | null
  lng: number | null
  assetType: string
  assetSubtype: string | null
  yearBuilt: number | null
  yearRenovated: number | null
  unitsOrSf: number | null
  numberOfUnits: number | null
  stories: number | null
  transactionType: string | null
  transactionDate: string | null
  salePrice: number | null
  pricePerUnit: number | null
  pricePerSf: number | null
  capRate: number | null
  occupancyAtSale: number | null
  noiAtSale: number | null
  isOurDeal: boolean
  isEvaluated: boolean
}

export const compsService = {
  search: (params: { assetType?: string; city?: string; state?: string; metro?: string }) =>
    api
      .get('/comps/', {
        params: {
          asset_type: params.assetType || undefined,
          city: params.city || undefined,
          state: params.state || undefined,
          metro: params.metro || undefined,
        },
      })
      .then((r) => toCamelCase<CompRecord[]>(r.data)),
}
